<template>
  <div class="chart-header__wrapper">
    <component
      class="pigeondoc__heading chart-header__title document-node__active"
      contenteditable="true"
      ref="heading"
      :is="value.meta.headingLevel || 'h2'"
      @input="onInput"
    />
  </div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import setCaretToEnd from '../../lib/setCaretToEnd';

export default {
  name: 'EditChartHeader',
  inject: ['editBus'],
  props: {
    value: PigeonDocNodeModel,
  },
  mounted() {
    if (this.value.meta.headingLevel) {
      this.setText();
    } else {
      const updated = {
        ...this.value,
        meta: {
          ...this.value.meta,
          headingLevel: 'h2',
        },
      };

      this.$emit('updateNode', updated);
    }
  },

  methods: {
    onInput() {
      this.editBus.update({ 'content.title': this.$refs['heading'].innerHTML });
    },
    setText() {
      this.$refs['heading'].innerHTML = this.value.content.title;
      this.$refs['heading'].focus();
      setCaretToEnd(this.$refs['heading']);
    },
  },
  watch: {
    'value.meta.headingLevel'() {
      this.$nextTick(() => this.setText());
    },
  },
};
</script>
